import {styled} from "@mui/material";

export const BalanceContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '1rem',
    marginBottom: '125px',
}));

export const BalancePageCard = styled('div')(({theme}) => {
    return {
        width: '100%',
        borderRadius: '0.5rem',
        border: `1px solid ${theme.barekam.additionalService.border.default}`,
        padding: '1rem 2rem',

        display: 'flex',
        alignItems: 'center',
        gap: '1rem',

        backgroundColor: '#fff',
        boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.1)',
    }
});

export const BalanceCardContent = styled('div')(() => ({
    backgroundColor: '#F1F1FB',
    padding: '1rem',
    borderRadius: '0.5rem',
    width: '12rem'
}));
